import { Document } from '@contentful/rich-text-types';
import { IPlan } from '../../../types/contentful';

interface Feature {
  includedInNumberOfPlans: number;
  title?: string | null;
  info?: Document | null;
  replaceCorePlanCheckWith?: string | null;
  copies: Map<string, string | undefined>;
}

export type Features = Feature[];

export const processPlans = (plans: IPlan[] | undefined) => {
  if (!plans) {
    return [];
  }
  return plans.reduce((acc: Features, plan, index: number) => {
    const { fields } = (plan as IPlan) ?? {};

    if (!fields || !fields.features) {
      return acc;
    }
    const features: Features = fields.features.flatMap(
      ({ fields: featureFields }) => {
        const existingElement = acc.find((e) => e.title == featureFields.title);
        const planName = fields.name;
        if (existingElement && planName) {
          existingElement.copies.set(
            planName,
            featureFields.replaceCorePlanCheckWith
          );
          return [];
        } else {
          const map = new Map<string, string | undefined>();
          if (planName) {
            map.set(planName, featureFields.replaceCorePlanCheckWith);
          }

          return [
            {
              ...featureFields,
              includedInNumberOfPlans: plans.length - index,
              copies: map
            }
          ];
        }
      }
    );

    acc = acc.concat(features);
    return acc;
  }, []);
};
